var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({staticClass:"ma-0",attrs:{"flat":"","small":"","icon":"","color":"grey","loading":_vm.loading,"data-test":"dowloadXlsxButton","disabled":_vm.disabled},on:{"click":() => {
          _vm.$emit('download');
        }}},on),[_c('v-icon',[_vm._v("grid_on")])],1)]}}])},[_c('span',[_vm._v("Экспорт в Excel")])])
}
var staticRenderFns = []

export { render, staticRenderFns }